import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, ButtonBase, Tooltip } from '@mui/material';

// project imports
import { set_theme_mode } from 'store/actions';

// assets
import { IconSun, IconMoon } from '@tabler/icons-react';

// ==============================|| LIGHT / DARK MODE TOGGLE ||============================== //

const ThemeModeToggle = ({ sx }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navType = useSelector((state) => state.customization.navType);
  const isDark = navType === 'dark';

  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  const toggleThemeMode = () => dispatch(set_theme_mode(isDark ? 'light' : 'dark'));

  return (
    <Tooltip title={label}>
      <ButtonBase
        onClick={toggleThemeMode}
        aria-label={label}
        sx={{
          borderRadius: '12px',
          overflow: 'hidden',
          // Hover styling lives here so it reacts to the button, not the icon chip.
          '&:hover .MuiAvatar-root': {
            background: theme.palette.secondary.dark,
            color: theme.palette.secondary.light
          },
          ...sx
        }}
      >
        <Avatar
          variant="rounded"
          aria-hidden
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            background: theme.palette.secondary.light,
            color: theme.palette.secondary.dark
          }}
          color="inherit"
        >
          {isDark ? (
            <IconSun stroke={1.5} size="1.3rem" />
          ) : (
            <IconMoon stroke={1.5} size="1.3rem" />
          )}
        </Avatar>
      </ButtonBase>
    </Tooltip>
  );
};

ThemeModeToggle.propTypes = {
  sx: PropTypes.object
};

export default ThemeModeToggle;
